import { View } from "components/view/view.component";
import { Text } from "components/text/text.component";
import style from './restaurantCard.component.module.css'
import { PieContent } from "components/pieCard/pieContent.component";

type RestaurantCardProps = {
    value?: number,
    title?: string
    total?: number
    showPie?: boolean
}

export function RestaurantCardComponent(props: RestaurantCardProps){
    const {value: _value, title, total: _total, showPie = false} = props;
    const value = _value !== undefined ? _value : 0
    const total = _total !== undefined ? _total : 100
    const valueInPercentage = ((_value ?? 0) / ( _total ?? 100)) * 100
    const percentage = ((value ?? 0) / ( total ?? 100)) * 100
    const color = percentage >= 80 ? 'var(--red-primary-color)' : percentage >= 70 ? 'var(--yellow-primary-color)' : 'var(--green-primary-color)'
    const pieColor = percentage >= 80 ? 'red' : percentage >= 70 ? 'yellow' : 'green'
    return (
        <View className={style.RestaurantCard} style={{height: !showPie ? 'var(--card-height)' : undefined}}>
            <View className={style.Content}>
                <View className={style.TitleSection} style={{justifyContent: showPie ? 'center' : 'flex-start'}}>
                    <Text className={style.Title} type="h5">{title}</Text>
                </View>
                <View className={style.ValueSection}>
                    {showPie ? <View className={style.PieContent}><PieContent value={valueInPercentage} unit='%' color={pieColor} max={total} /></View> :
                    <Text type="h2" style={{color: color}}>{_value !== undefined ? `${Math.floor(percentage)}%` : '---'}</Text> }
                    <Text type="h6">Ocupação Total</Text>
                    <PercentageBar value={value ?? 0} total={total ?? 100} />
                    <Text type="h6">{`${_value !== undefined ? value : '---'} de ${total} lugares`}</Text>
                    <Text type="h5" style={{color: color}}>{(value ?? 0) >= (total ?? 100) ? `lotado` : `+${(total ?? 100) - (value ?? 0)} vagas disponíveis`}</Text>
                </View>
            </View>
        </View>
    )
}

type percentageBarProps = {
    value: number
    total: number
}

function PercentageBar({value, total}: percentageBarProps){
    const percentage = ((value / total) * 100 >= 100) ? 100 : (value / total) * 100
    const color = percentage >= 80 ? 'var(--red-primary-color)' : percentage >= 70 ? 'var(--yellow-primary-color)' : 'var(--green-primary-color)'
    return (
        <View className={style.PercentageBarBackground}>
            <View className={style.PercentageBarFill} style={{width: `${percentage}%`, backgroundColor: color}}></View>
        </View>
    )
}